/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Subject_PlaceholderInputs */



/**
* | output |
* | --- |
* | "A short summary" |
*
* @param {Feedback_Subject_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_subject_placeholder = /** @type {((inputs?: Feedback_Subject_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Subject_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un bref résumé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Un breve resumen")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Um breve resumo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un breve riepilogo")
	return /** @type {LocalizedString} */ ("A short summary")
});